import type { SimpleGit } from 'simple-git';
import { parseNumstatLine } from './parse-numstat-entries.js';

export async function numstatFromGitNoIndex(
  g: SimpleGit,
  pathInRepo: string,
): Promise<{ additions: number; deletions: number } | null> {
  const devNull = process.platform === 'win32' ? 'NUL' : '/dev/null';
  try {
    const out = await g.raw(['diff', '--numstat', '--no-index', '--', devNull, pathInRepo]);
    const first = String(out).split('\n').find((l) => l.trim()) ?? '';
    const parsed = parseNumstatLine(first);
    if (!parsed) return null;
    return { additions: parsed.additions, deletions: parsed.deletions };
  } catch {
    return null;
  }
}
